import React, { SVGProps } from 'react';

const DragIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9.75 4.5C8.5095 4.5 7.5 3.4905 7.5 2.25C7.5 1.0095 8.5095 0 9.75 0C10.9905 0 12 1.0095 12 2.25C12 3.4905 10.9905 4.5 9.75 4.5ZM9.75 18C8.5095 18 7.5 16.9905 7.5 15.75C7.5 14.5095 8.5095 13.5 9.75 13.5C10.9905 13.5 12 14.5095 12 15.75C12 16.9905 10.9905 18 9.75 18ZM9.75 11.25C8.5095 11.25 7.5 10.2405 7.5 9C7.5 7.7595 8.5095 6.75 9.75 6.75C10.9905 6.75 12 7.7595 12 9C12 10.2405 10.9905 11.25 9.75 11.25ZM2.25 4.5C1.0095 4.5 0 3.4905 0 2.25C0 1.0095 1.0095 0 2.25 0C3.4905 0 4.5 1.0095 4.5 2.25C4.5 3.4905 3.4905 4.5 2.25 4.5ZM2.25 18C1.0095 18 0 16.9905 0 15.75C0 14.5095 1.0095 13.5 2.25 13.5C3.4905 13.5 4.5 14.5095 4.5 15.75C4.5 16.9905 3.4905 18 2.25 18ZM2.25 11.25C1.0095 11.25 0 10.2405 0 9C0 7.7595 1.0095 6.75 2.25 6.75C3.4905 6.75 4.5 7.7595 4.5 9C4.5 10.2405 3.4905 11.25 2.25 11.25Z"
                fill="#F9F9F9"
            />
        </svg>
    );
};

export default DragIcon;
